import script from "./SearchResultsGeneric.vue?vue&type=script&lang=js"
export * from "./SearchResultsGeneric.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__